import WeeklyMessage from './WeeklyMessage';

export default WeeklyMessage;
